module.exports = __webpack_public_path__ + "static/vib_play5s-cc3a293a89fff1888d276b75b30173d3.jpg";